import React, { useState } from "react";
import "./Contact.css";
import send from "../../../../assets/images/Contact/Vector(5).png";
import { Toaster, toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { noAuthConfig } from "../../../../api-config/authConfig";
import Filter from "bad-words";
import ReCAPTCHA from "react-google-recaptcha";

function Contact({ myRef, mainref }) {
  const { t } = useTranslation();
  const [formdata, setFormdata] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const changefn = (e) => {
    const profanityfn = (word) => {
      const loopfn = (word) => {
        return "*".repeat(word.length);
      };
      const x = []; // add words inside the array
      let newValue = e.target.value;

      for (let i in x) {
        const regex = new RegExp(x[i], "gi");
        if (regex.test(newValue)) {
          toast.error("Please refrain from using inappropriate language.");
          newValue = newValue.replace(regex, loopfn(x[i]));
        }
      }
      return newValue;
    };

    setFormdata({ ...formdata, [e.target.name]: profanityfn(e.target.value) });
  };

  const validateForm = () => {
    let isValid = true;
    const updatedErrors = {};
    if (formdata.name.trim() === "") {
      updatedErrors.name = t("Name is required");
      isValid = false;
    }
    const phonePattern = /^\+?\s?\d+(?:[\s-]\d+)*$/;
    if (!phonePattern.test(formdata.phone)) {
      updatedErrors.phone = t("Invalid phone number");
      isValid = false;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailPattern.test(formdata.email)) {
      updatedErrors.email = t("Invalid email format");
      isValid = false;
    }
    if (formdata.message.trim() === "") {
      updatedErrors.message = t("Message is required");
      isValid = false;
    }

    if (Object.keys(updatedErrors).length > 0) {
      Object.values(updatedErrors).forEach((errorMsg) => {
        toast.error(errorMsg);
      });
    }

    setErrors(updatedErrors);
    return isValid;
  };

  const [reCaptchaToken, setReCaptchaToken] = useState("");
  const handleRecaptcha = (value) => {
    setReCaptchaToken(value);
  };

  const submitfn = (e) => {
    e.preventDefault();
    if (validateForm()) {
      noAuthConfig
        .post("/contactus", formdata)
        .then((res) => {})
        .catch((err) => {});

      setTimeout(() => {
        toast.success("Message sent successfully");
        setFormdata({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
      }, 1000);
    }
  };
  return (
    <>
      <div className="contact" ref={mainref}>
        <div className="contact-container-2">
          <div className="contact-text">
            <div className="contact-text-head">
              <p>{t("Get in Touch")}</p>
            </div>
            <div className="contact-text-para">
              <p>{t("Make Sure")}</p>
            </div>
          </div>
          <div className="contact-form">
            <Toaster position="top-center" reverseOrder={false} />
            <form onSubmit={submitfn}>
              <p className="contact-form-head"> {t("Contact us")}</p>
              <div className="row">
                <div className="col contact-cols">
                  <input
                    ref={myRef}
                    type="text"
                    onChange={changefn}
                    value={formdata.name}
                    name="name"
                    required
                    className="form-control"
                    placeholder={t("Name")}
                  />
                  <div className="error">{errors.name}</div>
                </div>
                <div className="col contact-cols">
                  <input
                    type="tel"
                    minLength={5}
                    maxLength={15}
                    onChange={changefn}
                    value={formdata.phone}
                    name="phone"
                    required
                    className="form-control"
                    placeholder={t("Phone Number")}
                  />
                  <div className="error">{errors.phone}</div>
                </div>
              </div>

              <div className="form-group">
                <input
                  type="text"
                  onChange={changefn}
                  value={formdata.email}
                  name="email"
                  required
                  className="form-control"
                  placeholder={t("Email")}
                />
                <div className="error">{errors.email}</div>
              </div>
              <div className="mb-3">
                <textarea
                  placeholder={t("Message")}
                  className="form-control"
                  onChange={changefn}
                  name="message"
                  value={formdata.message}
                  required
                  rows={5}
                ></textarea>
                <div className="error">{errors.message}</div>
              </div>
              <div className="row mb-3" >
                <div className="col"></div>
                <div className="col">
                  <ReCAPTCHA
                    sitekey={`6LdpNM8pAAAAAKC_s1Z8ZoGFoEgbypdmEWSkY_52`}
                    onChange={handleRecaptcha}
                  />
                </div>
                <div className="col"></div>
              </div>

              <button
                type="submit"
                className="btn btn-primary form-btn"
                disabled={(reCaptchaToken?.length == 0 && reCaptchaToken!=null) ? true : false}
              >
                {t("Send")}
                <span className="send-img">
                  <img src={send} alt="send" />
                </span>
              </button>
            </form>
          </div>
        </div>
        {/* <Address/> */}
      </div>
    </>
  );
}

export default Contact;
